module.exports = __webpack_public_path__ + "static/img/icon17.85e1a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon17.png
// module id = fSGv
// module chunks = 0